import { zodResolver } from '@hookform/resolvers/zod';
import { PAYMENT_SITUATIONS, paymentSchema, type Payment } from '@pgs/shared';
import { useForm } from 'react-hook-form';
import { focusFirstError } from '../focusFirstError';
import { NavButtons } from '../NavButtons';
import { StepPanel } from '../StepPanel';
import { RadioGroup } from '@/components/form/RadioGroup';

interface Props {
  defaultValues?: Partial<Payment>;
  onBack: () => void;
  onSubmit: (values: Payment) => void;
}

export const Step6Payment = ({ defaultValues, onBack, onSubmit }: Props) => {
  const { control, handleSubmit } = useForm<Payment>({
    resolver: zodResolver(paymentSchema),
    defaultValues,
    mode: 'onChange',
  });
  return (
    <StepPanel
      icon="fa-pound-sign"
      title="New Starter Information"
      description="Please choose the answer that matches your current circumstances."
    >
      <form onSubmit={handleSubmit(onSubmit, focusFirstError)}>
        <RadioGroup
          control={control}
          name="situation"
          label="P46 Status — Select your employment situation"
          options={(Object.entries(PAYMENT_SITUATIONS) as [keyof typeof PAYMENT_SITUATIONS, string][]).map(
            ([value, label]) => ({ value, label }),
          )}
        />
        <NavButtons onBack={onBack} submit />
      </form>
    </StepPanel>
  );
};
